var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepositMobileSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.980469,
    y: 0.395508,
    width: 42.2277,
    height: 42.2277,
    rx: 21.1139,
    fill: "#3F7DBC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 26.1996V30.8916L11.5391 22.6807L19.75 14.4697V19.279C25.615 19.279 29.7205 17.4022 32.6529 13.2967C31.4799 19.1617 27.961 25.0266 19.75 26.1996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositMobileSvg);
export default __webpack_public_path__ + "static/media/depositMobileSvg.1f8d989a51eb9f84b34f6d5c4846fe74.svg";
export { ForwardRef as ReactComponent };